module.exports = __webpack_public_path__ + "img/preset_item_small.eb66d57b.png";